import { render, staticRenderFns } from "./SearchCinema.vue?vue&type=template&id=6c87b201&scoped=true&"
import script from "./SearchCinema.vue?vue&type=script&lang=js&"
export * from "./SearchCinema.vue?vue&type=script&lang=js&"
import style0 from "./SearchCinema.vue?vue&type=style&index=0&id=6c87b201&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87b201",
  null
  
)

export default component.exports